/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  GET_PAYOUT_DETAIL: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.platium-boilerplate.payoutDetailPage.payoutDetail',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'GET_PAYOUT_DETAIL' },
      },
    },
    GET_PAYOUT_DETAIL: {
      invoke: {
        id: 'payoutDetail',
        src: 'payoutDetail',
        onDone: {
          target: 'RENDER_PAYOUT_DETAIL',
          actions: ['successAction'],
        },
        onError: {
          target: 'RENDER_PAYOUT_DETAIL_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    RENDER_PAYOUT_DETAIL: {
      type: 'final',
    },
    RENDER_PAYOUT_DETAIL_ERROR: {
      type: 'final',
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
